import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=40b5eb56&scoped=true&"
import script from "./PaymentSettings.vue?vue&type=script&lang=js&"
export * from "./PaymentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5eb56",
  null
  
)

export default component.exports